import { pushFormattedGtmEvent } from '@/logic/metrika/helpers'
import { EAgroservicesRoute, EPriceUom } from '@/types'
import { EAgroservicesTypes } from './enums'
import { ArgoservicesClickGtmEventPayload } from './gtmConstants'
import type { IAgroService } from './interfaces'
import { messages } from './messages'

export const AGROSERVICES_CARDS: IAgroService[] = [
  {
    productId: 'fieldEvaluationReport',
    url: EAgroservicesRoute.fieldEvaluationReport,
    blockType: EAgroservicesTypes.WIDE,
    mainActionText: messages.card.actions.readMore,
  },
  {
    productId: 'seedingRateCalc',
    url: EAgroservicesRoute.seedingRateCalc,
    mainActionText: messages.card.actions.calculate,
  },
  {
    productId: 'agrocalculator',
    url: EAgroservicesRoute.agrocalc,
    mainActionText: messages.card.actions.calculate,
  },
  {
    productId: 'ef_plus',
    url: EAgroservicesRoute.polePlus,
    logo: 'exactFarmingWhite',
    onClick: () => pushFormattedGtmEvent(ArgoservicesClickGtmEventPayload.polePlus),
    price: {
      value: 20_000,
      uom: EPriceUom.RUB,
    },
    oldPrice: {
      value: 18_000,
      uom: EPriceUom.RUB,
    },
    paymentPeriod: messages.card.perYear,
    mainActionText: messages.card.actions.readMore,
  },
  {
    productId: 'ef_diff',
    url: EAgroservicesRoute.poleDiff,
    logo: 'exactFarmingWhite',
    onClick: () => pushFormattedGtmEvent(ArgoservicesClickGtmEventPayload.poleDiff),
    mainActionText: messages.card.actions.readMore,
  },
  {
    productId: 'ef_expert',
    url: EAgroservicesRoute.poleExpert,
    logo: 'exactFarmingWhite',
    onClick: () => pushFormattedGtmEvent(ArgoservicesClickGtmEventPayload.poleExpert),
    mainActionText: messages.card.actions.readMore,
  },
  {
    productId: 'ef_scout',
    url: EAgroservicesRoute.poleScouting,
    logo: 'exactFarmingWhite',
    onClick: () => pushFormattedGtmEvent(ArgoservicesClickGtmEventPayload.poleScouting),
    mainActionText: messages.card.actions.readMore,
  },
  {
    productId: 'efisZsn',
    url: EAgroservicesRoute.efisZsn,
    logo: 'efisZsn',
    blockType: EAgroservicesTypes.WIDE,
    mainActionText: messages.card.actions.readMore,
  },
  {
    productId: 'consulting',
    url: EAgroservicesRoute.agroconsulting,
    onClick: () => pushFormattedGtmEvent(ArgoservicesClickGtmEventPayload.blockAgronomicSupport),
    mainActionText: messages.card.actions.readMore,
  },
  {
    productId: 'soil_landscape_survey',
    url: EAgroservicesRoute.farmlandCropValuation,
    logo: 'argonoutWhite',
    onClick: () => pushFormattedGtmEvent(ArgoservicesClickGtmEventPayload.farmlandСropValuation),
    mainActionText: messages.card.actions.readMore,
  },
  {
    productId: 'faq',
    url: '/faq',
    mainActionText: messages.card.actions.findAnswer,
  },
  {
    productId: 'youDo',
    url: EAgroservicesRoute.youDo,
    blockType: EAgroservicesTypes.WIDE,
    logo: 'youDo',
    mainActionText: messages.card.actions.readMore,
  },
]
